export default defineNuxtPlugin(() => {
  const { loadFromLocalStorage, syncFavouritesFromServer, clearFavourites } = useFavouriteVehicle()
  const user = useAuthUser()
  // Restore cached favourites immediately on refresh
  loadFromLocalStorage()
  // Automatically handle logins and logouts
  watch(
    () => user.value,
    (newUser) => {
      if (newUser) {
        syncFavouritesFromServer()
      } else {
        clearFavourites()
      }
    },
    { immediate: true }
  )
})
